import * as Routes from '@/../types/constants/web_client_user.routes';

export function isOnboardingRoute(name: string): boolean{
	return name === Routes.RootOnboarding || name === Routes.CoachProfileSetup || name === Routes.AthleteProfileSetup;
}